module.exports = __webpack_public_path__ + "img/Myinstagram.22ff8674.svg";